import React from "react";
import { PostType } from "@/types/post";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { format } from "date-fns";

interface QuotedPostProps {
  post: PostType | null;
  originalPostId: string | null;
  onPostClick?: (post: PostType) => void;
}

export function QuotedPost({ post, originalPostId, onPostClick }: QuotedPostProps) {
  if (!post || !originalPostId) return null;

  return (
    <div
      className="block mt-2 cursor-pointer"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onPostClick && post) {
          onPostClick(post);
        }
      }}
    >
      <div className="border rounded-lg p-4 hover:bg-accent/50 transition-colors">
        <div className="flex items-center gap-2 mb-2">
          <Avatar className="h-5 w-5">
            <AvatarImage src={post.user?.image || post.image || undefined} />
            <AvatarFallback>{(post.user?.name || post.name)[0]}</AvatarFallback>
          </Avatar>
          <span className="font-medium">{post.user?.name || post.name}</span>
          <span className="text-muted-foreground">@{post.user?.username || post.user_username || post.username || 'user'}</span>
          <span className="text-muted-foreground">·</span>
          <span className="text-muted-foreground">
            {format(new Date(post.createdAt), "MMM d")}
          </span>
        </div>
        <p className="text-sm text-muted-foreground">{post.content}</p>
      </div>
    </div>
  );
}